import { AuthService } from '@/core/auth'
import axios from '@/core/http'

const auth = new AuthService()

export default {
  namespaced: true,
  state: {
    token: auth.getToken(),
    user: null,
  },
  actions: {
    async FETCH_USER({ commit }) {
      const { data } = await axios.get('/users/self/')
      commit('SET_USER', data)
    },
    async LOGIN({ commit, dispatch }, { username, password }) {
      const { data } = await axios.post('/token/', { username, password })
      const token = data.access

      auth.setToken(token)

      dispatch('FETCH_USER')
      commit('SET_TOKEN', token)
    },
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    LOGOUT: state => {
      state.user = null
      state.token = null
      auth.clearToken()
    },
  },
  getters: {
    isAuthenticated: state => !!state.token,
    isAdmin: state => state.user?.is_admin,
  },
}
